import app, { Component } from 'apprun';
import { users as usersApi, obApi } from './api';
import moment from 'moment';
import Company from './company';
import { isValid, showSaveStatusMessage, setDisabledButton } from './utils';

export default class OB_SelAgentsComponent extends Component {
  dateFmt = 'DD-MMM-YYYY';

  state = {
    //...this.state.state,
    usersRead: [],
    users: [],
    startDate: '',
    endDate: '',
    txfrComp: false
  };

  DateRangeEdit = ({ state }) => {
    return (
      <div>
        <div class="row">
          <label class="col-sm-5">User End Date</label>
          <label class="col-sm-5">User Start Date</label>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <input
              $pikaday
              autocomplete="off"
              id="endDate"
              size="62"
              value={state.endDate}
              class="form-control"
              data-validate="Date"
              onchange={e => this.run('endDate-changed', e)}
            />
          </div>
          <div class="col-sm-5">
            <input
              $pikaday
              autocomplete="off"
              id="startDate"
              size="62"
              value={state.startDate}
              class="form-control"
              data-validate="Date"
              onchange={e => (state.startDate = e.target.value)}
              disabled
            />
          </div>
        </div>
        <div class="row">
          <div id="endDateErrMsg" class="text-danger col-sm-5"></div>
          <div id="startDateErrMsg" class="text-danger col-sm-5"></div>
        </div>
      </div>
    );
  };

  UserItem = ({ item }) => {
    if (item.selected === true) {return;}
    return (
      <tr
        style={{ display: 'table-row' }}
        onclick={
          !item.locked
            ? (e) => {
              this.run('user-select', item, e);
            }
            : ''
        }>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.permissionLvl}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.name}
          </span>
        </td>
      </tr>
    );
  };

  UserList = ({ state }) => {
    return (
      <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover">
        <thead>
          <tr>
            <th>Title</th>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          {state.users.map(item => (
            <this.UserItem item={item} />
          ))}
        </tbody>
      </table>
    );
  };

  userSelector = ({ state }) => {
    return (
      <div class="panel" style={{ 'max-height': '50%' }}>
        <h2>Available Users</h2>
        <div class="input-group">
          <input
            class="form-control"
            placeholder="Search..."
            oninput={e => this.run('search', e)}
            value={state.filter || ''}
          />
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" onclick={() => this.run('select-all')}>
              {' '}
              Select All{' '}
            </button>
          </span>
        </div>
        <div style={{ 'white-space': 'normal', 'word-wrap': 'break-word' }}>
          <this.UserList state={state} />
        </div>
      </div>
    );
  };

  selectedUsers = ({ state }) => {
    return (
      <div class="panel" style={{ 'max-height': '20%', 'min-height': '10%', width: '100%' }}>
        <table>
          {state.usersRead
            .filter(p => p.selected)
            .map(p => (
              <tr>
                <td>
                  {p.name}&nbsp;({p.permissionLvl})&nbsp;
                  <a class="btn btn-xs" onclick={e => this.run('user-deselect', p, e)}>
                    ✂
                  </a>
                </td>
              </tr>
            ))}
        </table>
      </div>
    );
  };

  // prettier-ignore
  view = (state) => {
    if (!state) {return;}

    return (
      <div style={{ width: '450px', 'height': '70vh' }}>
        <style>{'.disable {pointer-events: none;  cursor: not-allowed;  opacity: 0.6;}'} </style>
        <h3>  RLP to RLP  </h3>
        <h2>  Select the Agents to transfer  </h2>
        {(state.txfrComp)?<h3 style={{ color: 'green' }}>Successfully Transferred</h3>:''}&nbsp;&nbsp;
        {(state.txfrComp)?<button class="btn btn-primary btn-xs row" onclick={() => this.run('finish')} >Finish</button>:''}
        <br/>
        <form id="ob_selAgentsForm">
          <this.DateRangeEdit state={state} />
        </form>
        <br/>
        <h2>  Selected Users  </h2>
        <this.selectedUsers state={state} />

        <div id="returnedErrMsg" class="text-danger row" style={{ width:'90%', 'white-space':'normal' }} >{state.saveError}</div>
        <br/>

        <div style={{ display: (state.txfrComp)?'none':'block' }}>
          <div class="edit-buttons row">
            <button class="btn btn-primary btn-xs pull-right" onclick={e => this.run('continue', e)} id='transfer' name ='transfer' >Transfer</button>
            <button class="btn btn-default btn-xs pull-right" onclick={() => this.run('cancel')} >Cancel</button>
          </div>

          <this.userSelector state={state} />
          <br/><br/>
        </div>
      </div>
    );
  }

  update = {
    refresh: async (state, newState) => {
      state = { ...state, ...newState };
      const criteria = {
        companyId: state.from.company,
        locationId: state.from.location,
        customFilter: '{ACTIVE=1}',
        maxResults: 5000
      };
      const users = await usersApi.searchAdvance(criteria);
      return { ...state, filter: '', startDate: '', endDate: '', saveError: '', txfrComp: false, users, usersRead: users };
    },

    search: (state, e) => {
      state.filter = e.target.value;
      state.users = state.usersRead.filter(u => u.name.toUpperCase().indexOf(state.filter.toUpperCase()) >= 0);
      return state;
    },

    'endDate-changed': (state, e) => {
      const sameEndDate = state.endDate === e.target.value;
      state.endDate = e.target.value;
      if (!sameEndDate ) {
        state.startDate = moment(state.endDate, this.dateFmt)
          .add(1, 'days')
          .format(this.dateFmt);
        const startDate = document.getElementById('startDate') as HTMLInputElement;
        startDate.value = state.startDate;
      }
    },

    'user-select': (state, item) => {
      item.selected = true;
      return state;
    },

    'select-all': (state) => {
      state.users.map(u => (u.selected = true));
      return state;
    },
    'user-deselect': (state, item) => {
      item.selected = false;
      return state;
    },

    continue: (state, e) => {
      const formName = 'ob_selAgentsForm';
      let validDates = isValid(formName);
      if (validDates && moment(state.startDate, this.dateFmt) <= moment(state.endDate, this.dateFmt)) {
        validDates = false;
        const errMsg = document.getElementById('startDateErrMsg') as HTMLDivElement;
        errMsg.innerHTML = 'New Start date must be after End date';
      }

      const usersSelected = state.usersRead.filter(p => p.selected).map(p => p.personID);
      if (usersSelected.length === 0) {
        const errMsgDiv = document.getElementById('returnedErrMsg') as HTMLDivElement;
        errMsgDiv.innerHTML = '* no users are selected';
      }

      if (!validDates || !usersSelected) {return;}

      const agentTranferModel = {
        fromCompany: state.from.company,
        fromLocation: state.from.location,
        toCompany: state.to.company,
        toLocation: state.to.location,
        endDate: state.endDate,
        startDate: state.startDate,
        personIds: usersSelected
      };
      this.run('save', agentTranferModel, e);
    },

    save: async (state, model, e) => {
      let result;

      try {
        setDisabledButton(e.target);
        result = await obApi.transferAgents(model);
        state.saveError = null;
        showSaveStatusMessage('agent');
      } catch (ex) {
        const errorMsg = await ex.json();
        state.saveError = '* ' + errorMsg;
        showSaveStatusMessage();
      }finally {
        setDisabledButton(e.target, false);
      }

      if (result) {state.txfrComp = true;}

      return state;
    },

    cancel: (state) => {
      app.run('#clear-panel', state.panelId);
    },

    finish: (state) => {
      app.run('#add-panel', {
        id: 'company',
        title: state.to.companyName,
        Component: Company,
        level: 2,
        state: { companyId: state.to.company, caller: this }
      });
    }
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
